import { ConstructionOutlined, Edit, EditOff, LocalConvenienceStoreOutlined, LocalDining, ShoppingBag, SportsMotorsports, Subject } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import MyDateTime from "../../../DTechComp/MyDateTime";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import TheMount from "../../../OrderSettings/TheMount";
import ConnUrls from "../../../Connections/ConnectURL";
import { MobiOrNotContext } from "../../../ContextApi/context";
import TheWeightSelect from "../../../OrderSettings/TheWeightSelect";


const ShowMyOrder = (props) => {
    // const [order, setOrder] = useContext(OrderContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext)

    const [theOrder, setTheOrder] = useState(props.theOrder)

    const [intervalID, setIntervalID] = useState();



    useEffect(() => {
        getTimes();
    }, [])


    const getTimes = () => {

        stopHandler()
        startHandler()
    }

    const stopHandler = () => {
        clearInterval(intervalID)
    }


    //הצג או הסתר הערות על המנה
    const showHideRemarks = (elemId) => {
        let Remarks = document.getElementById(`${elemId}_remarks`);
        let RemarksItm = document.getElementById(`${elemId}_remarksTxt`);
        let RemarksItmTxt = document.getElementById(`${elemId}_remarkstxLine`);

        if (Remarks.classList.contains("slideMeUp")) {
            Remarks.classList.remove("slideMeUp");
            RemarksItmTxt.classList.add("slideMeUp");
        }
        else {
            Remarks.classList.add("slideMeUp");
            RemarksItmTxt.classList.remove("slideMeUp");
        }
    }


    //הסתר או הצג כמות של מנה מסויימת
    const showHideMount = (elemId) => {

        let mountItm = document.getElementById(elemId);

        if (mountItm.classList.contains("slideMeUp")) {
            mountItm.classList.remove("slideMeUp");
        }
        else {
            mountItm.classList.add("slideMeUp");
        }
    }


    const startHandler = () => {

        if (intervalID != null) {
            clearInterval(intervalID)
        }
        setIntervalID(setInterval(() => {
            let theId = "_Ord";
            var theELEMENT = window.document.getElementById(theId);
            if (theELEMENT) {
                if (theOrder.orderStatus != "סגור" && theOrder.orderStatus != "מושהה" && theOrder.orderStatus != "מבוטל"
                    && theOrder.orderStatus != "בקשה לסגירה" && theOrder.orderStatus != "בקשה לביטול") {
                    let theItm = MyDateTime.getTimeLeftTilThen(theOrder.scheduledFor || theOrder.dateCreated, theOrder.OrderTimes);
                    if (!theItm.theEnd) {
                        theELEMENT.innerText = theItm.theTm
                    }
                    else {
                        theELEMENT.innerText = "00:00";
                    }
                }
                else {
                    theELEMENT.innerText = ""
                }
            }

        }, 1000));
    }


    let orderOrTake = () => {
        if (theOrder.OrderType == "Take")
            return (
                <div className={"ordTypeCard"}>
                    <div className={"ordTypeCardIcon"}><ShoppingBag /></div>
                    <div className={"ordTypeCardTxt"}>
                        <div className={"bold"}>איסוף עצמי</div>
                    </div>
                </div>
            )
        else {
            let addrs = theOrder.deliveryAddress
            if (addrs) {
                return (
                    <div className={"ordTypeCard"}>
                        <div className={"ordTypeCardIcon"}><SportsMotorsports /></div>
                        <div className={"ordTypeCardTxt"}>
                            <div className={"bold"}>משלוח</div>
                            <div className={"regular"}>
                                {addrs.street}&nbsp;
                                {addrs.num}&nbsp;
                                {(addrs.appartment != null && addrs.appartment != "") ? `דירה: ${addrs.appartment}` : ""}&nbsp;
                                {(addrs.ent != null && addrs.ent != "") ? `כניסה: ${addrs.ent}` : ""}&nbsp;
                                {(addrs.flor != null && addrs.flor != "" && addrs.num != "") ? `קומה: ${addrs.flor}` : ""}&nbsp;
                                {(addrs.city != null && addrs.city != "") ? ` ${addrs.city}` : " אשדוד"}
                                <br />
                                {(addrs.entryCode != null && addrs.entryCode != "") ? `קוד כניסה: ${addrs.entryCode}` : ""}  <br />
                                {(addrs.remarks != null && addrs.remarks != "") ? `הערות לשליח: ${addrs.remarks}` : ""}
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }



    ///המוצרים בהזמנה
    let ordersItems = theOrder.Orders.map((item, index) => {
        // חישוב מחיר - אם זה מוצר שקיל, מחשבים לפי המשקל
        const displayPrice = item.weightValue !== undefined
            ? ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2)
            : (parseFloat(item.prodPrice) * parseInt(item.mount)).toFixed(2);

        return (
            <div key={index} className={"ordItem spaceButtomBig "}>

                <div className={"ordItmLine"}>

                    <div className={`${!mobiOrNot ? "col-8 onRight" : "col-12 onRight"}`}>
                        {item.weightValue !== undefined ? (
                            // תצוגה למוצר שקיל
                            <>
                                <span className={"bold rSideMiddle"}>
                                    <span className={"ordItemMount"}>{item.productName}</span>
                                </span>
                                <span className={"bold lSideSmall"}>
                                    <div>{(item.weightValue / 1000).toFixed(2)} ק"ג</div>
                                    <div>₪ {displayPrice}</div>
                                </span>
                            </>
                        ) : (
                            // תצוגה למוצר רגיל
                            <div className={"ordItmLine"}>
                                <div className='col-12 fullRow overflowHid'>
                                    <div className='col-9 onRight overflowHid'>
                                        <div className='col-12 overflowHid'>
                                            <div className='col-2 onRight tdmin10 overflowHid'>
                                                <span className={"ordItemMount mainMount"}>{item.mount} יח'&nbsp;</span>
                                            </div>
                                            <div className='col-6 onRight overflowHid'>
                                                <span className={"fullRow big"}> {item.productName} </span>
                                                <span className={"fullRow small"}> {item.prodInfo} </span>
                                                <span className={"fullRow small"}> {item.unitPrice} </span>
                                            </div>
                                            <div className='col-4 onRight overflowHid'>
                                                <div className={"imgOnCart"}>
                                                    {item.prodImageUrl ? <img src={`${ConnUrls.media(item.prodImageUrl)}`}
                                                        className={"smallDIspImage"} alt={item.prodName} />
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-3 onLeft overflowHid'>
                                        <span style={{ textAlign: "left", paddingBottom: "10px" }}
                                            className={"bold col-12 onLeft big"}>
                                            {item.weightValue !== undefined
                                                ? ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2)
                                                : (parseFloat(item.prodPrice) * parseInt(item.mount)).toFixed(2)
                                            } ₪
                                        </span>


                                    </div>
                                </div>
                            </div>
                        )}

                        <div className={"fullRow overflowHid"}>
                            {OrderFunctions.theItemSpecials(item)}
                        </div>

                    </div>

                </div>


            </div >

        )

    })


    //רטבים מוצמדים מוזמנים
    let stickedSauces =
        theOrder.StickedSauces?.length > 0 ?
            <div className={"spaceButtomBig ordLstSpesBlk "}>
                <div className={"smallIconWrap"}>
                    <img src={"/PermanentImages/suse-icon.png"} className={"smallIcon"} alt="רוטב" />
                </div>
                <span className={"bold fullRow "}>רטבים מוצמדים</span><span className={"veryVerySmall"}>&nbsp;{(theOrder.freeSaucess > 0) ? `(${theOrder.freeSaucess} ללא עלות)` : ""} </span>
                <span className={"bold lSideSmall"}>{OrderFunctions.getStickedSauces(theOrder) > 0 ? OrderFunctions.getStickedSauces(theOrder) + "  ₪" : ""} </span>

                {
                    theOrder.StickedSauces?.map((sauce, indx) => {
                        return (
                            <div key={indx} className={"sucItem"}>

                                <span className={"rSideMiddle"}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={"tdmin10"}>
                                                    <span className={"ordItemMount"}>{sauce.mount} יח'&nbsp;</span>
                                                </td>
                                                <td>
                                                    <span className={"ordItemMount"}> {sauce.servType}</span>
                                                </td>
                                                <td>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                            </div>
                        )
                    })
                }
            </div>
            : "";




    //מספר סועדים
    let Dinners =
        (theOrder.getfANife || theOrder.getChupstiks) ?
            <div className={"sucItem spacePadSmall"} >
                <span className={"rSideMiddle"}><span className={"bold"}>מספר סועדים: </span><span>{theOrder.Dinners}</span></span>
            </div>
            : "";

    //סכו"ם
    let ANife =
        (theOrder.getfANife) ?
            <div className={"sucItem spacePadSmall"}>
                <span className={"rSideMiddle"}><span className={"bold"}>סכו"ם חד פעמי: </span><span>{theOrder.getfANife ? "כן" : "אין צורך "}</span></span>
            </div>
            : "";

    //צופסטיקס
    let chupstiks =
        (theOrder.getChupstiks) ?
            <div className={"sucItem spacePadSmall"}>
                <span className={"rSideMiddle"}><span className={"bold"}>צ'ופסטיקס: </span><span>{theOrder.getChupstiks ? "כן" : "אין צורך "}</span></span>
            </div>
            : "";



    let totalDinners =
        (Dinners != "" || ANife != "" || chupstiks != "") ?
            <div className={"ordItmLine spaceAndLine"}>
                <span className={"rSideFirst"}><LocalDining /></span>
                <span className={"rSideMiddle"}>
                    {Dinners}
                    {ANife}
                    {chupstiks}
                </span>
                <span className={"bold lSideSmall"}></span>
            </div>
            : ""



    //סיכום מחירים
    let TotPrices =
        <>
            <div className={"ordItmLine totalTxt"}>
                <div className={"bold totalTxtR"}>סכום ההזמנה</div>
                <div className={"bold totalTxtL"}>{parseFloat(OrderFunctions.getOrderPrice(theOrder)).toFixed(2)} ₪ </div>
            </div>

            {(theOrder.OrderType == "Deliver") ?
                <div className={"ordItmLine totalTxt"}>
                    <div className={"bold totalTxtR"}>משלוח</div>
                    <div className={"bold totalTxtL"}>{parseFloat(theOrder.OrderDelPrice).toFixed(2)} ₪ </div>
                </div> : ""}

            <div className={"ordItmLine totalTxt"}>
                <div className={"bold totalTxtR"}>סה"כ</div>
                <div className={"bold totalTxtL"}>{parseFloat(OrderFunctions.getOrderTotalPrice(theOrder)).toFixed(2)} ₪ </div>
            </div>

            {(theOrder.creditsUsed > 0) &&
                <>
                    <div className={"ordItmLine totalTxt"}>
                        <div className={"bold totalTxtR"}>אשדוד בתפריט קרדיט</div>
                        <div className={"bold totalTxtL"}>-{theOrder.creditsUsed} ₪</div>
                    </div>

                    <div className={"ordItmLine totalTxt"}>
                        <div className={"bold big totalTxtR"}>סה"כ לתשלום</div>
                        <div className={"bold big totalTxtL"}>{parseFloat(OrderFunctions.getOrderToPay(theOrder)).toFixed(2)} ₪ </div>
                    </div>
                </>}

            <div className={"big bold spacePad startNBlock centerText"}>כל המחירים בשקלים וכוללים מע"מ</div>


        </>

    //אופן תשלום
    const payingTYpe = () => {
        switch (theOrder.payt) {
            case "1":
                return "אשראי";
            case "2":
                return "מזומן";
            case "3":
                return "ביט";
        }
    }

    // "מספר אישור עסקה" ללקוח - creditCrdApprov (ApprovalNumber מחברת האשראי),
    // לא transactionId (מזהה פנימי של קארדקום, רלוונטי רק לאדמין).
    const approvalNumber = theOrder.tranzactionInfo?.[0]?.creditCrdApprov ?? theOrder.creditCrdApprov;
    const payText = theOrder.payt === "2" ? "תשלום במזומן"
        : approvalNumber === "0110" ? "שולם בקרדיטים"
        : approvalNumber ? "מספר אישור עסקה: " + approvalNumber
        : null;


    return (
        <>
            {
                theOrder.Orders.length <= 0 ?
                    <div className={"noItmes huge centerText"}>אין פריטים להזמנה.</div> :

                    <div className={"TheOrderListToDisp"}>
                        <div className={"TheOrderShow ordLstWrap"}>
                            {/* <div className={"veryBig bold spaceRightVeryLong"}>סוג ההזמנה</div> */}
                            {orderOrTake()}
                            {ordersItems}
                            {stickedSauces}
                            {totalDinners}
                            {(theOrder.orderKopon && theOrder.orderKopon != "") ?

                                <div key={'kop'} className={"ordItem spaceButtomBig "}>

                                    <div className={"ordItmLine"}>

                                        <span className={"bold rSideMiddle"}>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className={"tdmin10"}>
                                                            <span className={"engFont ordItemMount"}></span>
                                                            <span className={"ordItemMount mainMount"}></span>
                                                        </td>
                                                        <td>
                                                            <span className={"ordItemMount"}>קופון {theOrder.orderKopon.Name}</span>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </span>
                                        <span className={"bold lSideSmall"}>{theOrder.orderKopon.KoponDiscount}{theOrder.orderKopon.KoponDiscType === '1' ? "₪" : "%"}</span>
                                    </div>

                                </div>
                                : ""}

                            {(theOrder.orderZikoy && theOrder.orderZikoy != "") &&
                                theOrder.orderZikoy.map((element, index) => {
                                    return (
                                        <div key={`zikoy_${index}`} className={"ordItem spaceButtomBig "}>

                                            <div className={"ordItmLine"}>

                                                <span className={"bold rSideMiddle"}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className={"tdmin10"}>
                                                                    <span className={"engFont ordItemMount"}></span>
                                                                    <span className={"ordItemMount mainMount"}></span>
                                                                </td>
                                                                <td>
                                                                    <span className={"ordItemMount"}>זיכוי {element.Name}</span>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </span>
                                                <span className={"bold lSideSmall"}>₪{element.zickoyPrice}-</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            {/* {(theOrder.orderRemarks != null && theOrder.orderRemarks != "") ?
                            <div className={"bold big spacePadBig"}>{parse(theOrder.orderRemarks)}</div>
                            : ""} */}

                            <div className={"spaceTopBig fullWidth"}>
                                <div className={"regular bold onRight"}>צורת תשלום:</div>
                                <div className={"onRight spaceRight"}>{payingTYpe()}</div>
                            </div>
                            {payText &&
                                <div className={"spaceTopBig fullWidth"}>
                                    <div className={"regular bold onRight"}>סטטוס תשלום:</div>
                                    <div className={"onRight spaceRight"}>{payText}</div>
                                </div>
                            }

                            {TotPrices}
                        </div>
                    </div>
            }
        </>

    )

}

export default ShowMyOrder